import { render, staticRenderFns } from "./TopSpenderCampaignSection.vue?vue&type=template&id=894e75aa&scoped=true"
import script from "./TopSpenderCampaignSection.vue?vue&type=script&lang=js"
export * from "./TopSpenderCampaignSection.vue?vue&type=script&lang=js"
import style0 from "./TopSpenderCampaignSection.vue?vue&type=style&index=0&id=894e75aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "894e75aa",
  null
  
)

export default component.exports